export const AVAILABLE_CURRENCIES = {
  USD: '$',
  UAH: '₴',
  EUR: '€',
  BRL: 'R$',
}

export const USD_CURRENCY = 'USD'

export const CURRENCY_COUNTRY_CODES = {
  UAH: 'ua',
  USD: 'us',
  BRL: 'br',
}
